import React, { useEffect } from "react";
import ReduxProviders from "@/store/store-provider";
import "@/globals.css";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ConfirmationProvider } from "@/components/common/ConfirmationDialog";
import { GlobalLoading } from "@/components/common/GlobalLoading";

export function AppLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.title = "Shiphouse Seller Admin";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", "Shiphouse Seller Admin Panel");

    const wonder = document.createElement("script");
    wonder.async = true;
    wonder.src =
      "https://cdn.by.wonderpush.com/sdk/1.1/wonderpush-loader.min.js";
    document.head.appendChild(wonder);

    const inline = document.createElement("script");
    inline.async = true;
    inline.innerHTML = `window.WonderPush = window.WonderPush || [];\nWonderPush.push(["init", {webKey: "51e7fb48512eb0ec2479c1e6c1e34bd5712949a552db95fcd80af6d563af8325"}]);`;
    document.head.appendChild(inline);
  }, []);

  return (
    <ThemeProvider>
      <ConfirmationProvider>
        <ReduxProviders>
          {/* <p>Test </p> */}
          {children}
          <GlobalLoading />
        </ReduxProviders>
      </ConfirmationProvider>
    </ThemeProvider>
  );
}
